module.exports = __webpack_public_path__ + "img/mirror25.6409d59a.jpg";